import request from '@/utils/request'

// 通过广告ID查询-广告审核日志列表
export const listAdvertisementReviewLog = (id) => {
    return request.get(`/advertisementReviewLog/${id}`);
};
